<template>
    <div class="p-2 rounded border-b accordion faq">
        <div @click="$emit('toggleOpen', index)" :class="{ 'open': open, 'close': !open, 'tyc_title': tyc_title }" class="faq_question">
            {{ title }}
            <transition name="rotate">
                <div class="vtab" :class="open ? 'expand' : 'collapse'">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd" />
                    </svg>
                </div>
            </transition>
        </div>
        <div class="faq_answers" :class="open ? 'open' : 'close'">
            <div class="pt-1 pb-4">
                <p><slot></slot></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => {
            return {
                isOpen: false
            }
        },
        name: 'FAQ',
        props: ['title', 'faq', 'index', 'open', 'tyc_title']
    }
</script>

<style scoped>
.accordion a{
    @apply text-green-300 font-bold;
}
.collapse svg {
    transform:rotate(180deg);
    transition: all 300ms ease-out;
}
.expand svg {
    transform:rotate(0deg);
    transition: all 300ms ease-out;
}
.faq_question {
    @apply flex justify-between items-center content-center text-lg bg-white text-green-500 pt-2 pb-2 font-bold rounded cursor-pointer hover:text-green-300;
}
.tyc_title{
    font-size: 16px !important;
}
.faq_question.open {
    color:#1d5d25;
    transition: all 300ms linear;
}
.faq_answers.open {
    transition: all 300ms ease-in;
        opacity: 1;
        max-height: fit-content;
}
.faq_answers.close {
    transition: all 300ms ease-out;
}
.faq_answers {
    @apply text-lg mt-3 pb-4 rounded text-gray-800 overflow-hidden;
    opacity: 0;
    padding:0;
    margin:0;
    max-height: 0px;
    transition: all 300ms ease-out;
}
</style>